require('./bootstrap');
require('./_global');
require('./components/vue-declarator');



// WEBPACK FOOTER //
// ./resources/js/admin-panel/main.js